export { restrictedRoute } from './restrictedRoute';
